import { EdgeListChannelMembersRepository } from '@/modules/connect/infra'
import type { ListChannelMembers } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeListChannelMembers(): ListChannelMembers {
  return new EdgeListChannelMembersRepository(makeSupabaseEdgeHttpClient()).execute
}
